import React, { Component } from 'react';
import { v1 } from 'uuid';
import { useState, useRef, useEffect } from 'react';
import { loadJS, isJDiwork, getFileUrl } from '../../utils';
import { observer } from "mobx-react";
import hocWithBaseElementWrap from '@utils/hocWithBaseElementWrap';
import { utils } from 'ynf-core-middleware';
import { getMscByDomainKey } from 'ynf-core-engine/request';
import { isDesign } from '../../utils/tool';
import "./style/index.less"


const Ecsuite = (props) => {
  // 加载附件js等资源
  const {
    value,
    alias,
    pageStore,
    visible = true,
    nid,
    controlType,
    renderEnv,
    tabs
  } = props;
  const randomId = v1();
  const [objectId, setObjectId] = useState(value || randomId);
  const [instance, setInstance] = useState(null);
  let objectName = getMscByDomainKey?.(pageStore?.query?.domainKey) || pageStore?.query?.domainKey || 'developplatform';
  if (objectName === 'developplatform' && pageStore?.query?.domainKey === 'developplatform') {
    objectName = 'iuap-yonbuilder-runtime'
  }
  const node = `yb-ecsuite-${alias}-${objectId}`; // 容器元素
  const authId = pageStore?.query?.serviceCode || "ybbase";
  const ecsuiteDom = useRef(null);
  const [timer, setTimer] = useState(0);
  const [update, setUpdate] = useState(false);

  const init = () => {
    const ecsuiteParams = {
      tabs: props.tabs || ['comment', 'task', 'flow'],
      // 文件id
      objectId: props.value || randomId,
      // 调用方应用 code，必须先申请 注册 后方能使用 等
      objectName,
      // ybbase是应用构建菜单的serviceCode，在设计器状态下使用
      authId,
      // 组件渲染的容器
      el: `#${node}`,
      // 协同规则：原厂单据需要透传
      buttonAuthId: 'iuapfile-public'
    }
    if (ecsuiteDom) {
      ecsuiteDom.innerHTML = '';
    }

    instance?.close?.();

    YYCooperationBridge?.YYRenderCooperation(ecsuiteParams)?.then((instance) => {
      setInstance(instance);
      props.onChange?.(props.value || randomId);
      setObjectId(props.value || randomId);
    });
    
  }

  const debounceInit = () => {
    if (timer) {
      clearTimeout(timer);
    }
    setTimer(setTimeout(() => {
      init();
    }, 500));
  }

  // 初始化的时候加载组件
  useEffect(() => {
    loadFileResources(debounceInit);
  }, []);

  useEffect(() => {
    if (update) {
      loadFileResources(debounceInit);
      setUpdate(false);
    }
  }, [update]);


  useEffect(() => {
    if (value !== objectId) {
      setUpdate(true);
    }
  }, [value]);

  useEffect(() => {
    setUpdate(true);
  }, [tabs]);

  const loadFileResources = (callback) => {
    if (window.YYCooperationBridge?.ready) {
      window.YYCooperationBridge?.ready?.(() => {
        callback();
      });
      return;
    }
    if ((isJDiwork() && window.YYCooperationBridge) || window.uploadFileLoading) {
      const timer = setInterval(() => {
        // 如果js加载完毕，清除定时器，并执行init
        console.log('%c 加载文件js')
        if (window.YYCooperationBridge?.ready) {
          clearInterval(timer);
          window.YYCooperationBridge?.ready?.(() => {
            callback();
          });
        }
      }, 100)
    } else {
      window.uploadFileLoading = true;
      loadJS(
        getFileUrl(),
        'ybUploadFileservice',
        () => {
          callback();
        },
        () => {
          let flag = false
          window.YYCooperationBridge?.ready?.(() => {
            flag = true
            window.uploadFileLoading = false
          });
          return flag
        }
      )
    }
  }

  return (<div
    className={`yb-ecsuite ${isDesign(renderEnv) ? 'designer-style-yb-ecsuite' : ''} `}
    nid={nid}
    controlType={controlType}
    id={`${node}`}
    ref={ecsuiteDom}
  />)
}

export default hocWithBaseElementWrap(observer(Ecsuite))